// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"210":"be58545a","568":"9c3c91b2","629":"8d1ad06d","700":"312e4caa","787":"721d28d5","980":"1d212484"}[chunkId] + ".chunk.js";
};